module.exports = __webpack_public_path__ + "assets/img/edit-icon.9c55705e.png";